module.exports = __webpack_public_path__ + "img/namsan_gallery3.8512193f.jpg";